import { Controller } from "@hotwired/stimulus"

// Universal controller to enable submit buttons when form values change
// Used across all filter drill-down views (job titles, departments, dates, etc.)
export default class extends Controller {
  static targets = ["button"]

  connect() {
    // Disable button initially
    this.disableButton()
  }

  // Called on any input/change in the form
  enableButton() {
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.remove("dropdown-menu__submit--disabled")
    }
  }

  disableButton() {
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.add("dropdown-menu__submit--disabled")
    }
  }

  // Re-disable button after apply is clicked
  // Uses setTimeout to allow the actual apply action to run first
  disableAfterApply() {
    setTimeout(() => {
      this.disableButton()
    }, 100)
  }
}
